import React from 'react'

const DotIcon = ({ color = "#16A349" }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none">
    <circle cx="3" cy="3" r="3" fill={color} />
  </svg>
  )
}

export default DotIcon